import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCompanyItemSummaryById } from "../../ApiRequests";

export const fetchCompanyItemSummary = createAsyncThunk(
  "fetch/CompanyItemSummary",
  async (id) => {
    try {
      let response;
      response = await getCompanyItemSummaryById(id);
      // console.log(response?.data?.data?.payload?.data);

      return response?.data?.data?.payload?.data ?? [];
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const CompanyItemSummarySlice = createSlice({
  name: "CompanyItemSummary",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCompanyItemSummary.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchCompanyItemSummary.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchCompanyItemSummary.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default CompanyItemSummarySlice.reducer;
